export default {
  "and": "e",
  "Back": "Voltar",
  "Click to Expand": "Clique para Expandir",
  "Click to Hide": "Clique para Ocultar",
  "Click to Highlight": "Clique para Destacar",
  "Click to Show": "Clique para Mostrar",
  "Click to Show All": "Clique para Mostrar Tudo",
  "Download": "Baixar",
  "Loading Visualization": "Carregando Visualização",
  "more": "mais",
  "No Data Available": "Dados Não Disponíveis",
  "Powered by D3plus": "Funciona com D3plus",
  "Share": "Porcentagem",
  "Shift+Click to Hide": "Shift+Clique para Ocultar",
  "Shift+Click to Highlight": "Shift+Clique para Destacar",
  "Total": "Total",
  "Values": "Valores"
};